import { render, staticRenderFns } from "./FormTopic.vue?vue&type=template&id=4415c3ff&"
import script from "./FormTopic.vue?vue&type=script&lang=js&"
export * from "./FormTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports